import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import moment from 'moment';

function NoticeBoardView() {
    const navigate = useNavigate();
    const location = useLocation();
     const Note =  location.state?.data?.allData ||
    location.state?.data?.rawData ||
    location.state?.data; 
   let toDate = "";
if (Note?.start_date && Note?.no_of_days) {
    const startDateOnly = Note.start_date.split(" ")[0]; 
    toDate = moment(startDateOnly, "YYYY-MM-DD")  
        .add(Number(Note.no_of_days), "days")
        .format("YYYY-MM-DD");
}
    return (
            <div className='TaskEmployee-main mb-5'>
                <div className="page-title">
                    <h4>Notice Board</h4>
                    <div className="edit-btn">
                        <button
                            type="submit"
                            className="custom-btn"
                            onClick={() => navigate(-1)}
                        >Cancel</button>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12'>
                        <div className='View_Timesheet_Card'>
                            <div className='head_timesheet'>
                                <h6>Notice Details</h6>
                            </div>
                            <div className='body_timesheet'>
                                <div className='labeldiv_timesheet'>
                                    <h5>Notice Heading</h5>
                                    <h6>{Note?.heading || ""}</h6>
                                </div>
                                <div className='labeldiv_timesheet'>
                                    <h5>Date</h5>
                                    <h6>{Note?.start_date ? moment(Note.start_date).format("YYYY-MM-DD") : ""}</h6>
                                </div>
                                <div className='labeldiv_timesheet'>
                                    <h5>To</h5>
                                    <h6>{toDate || ""}</h6>
                                </div>
                                <div className='labeldiv_timesheet'>
                                    <h5>Description</h5>
                                    <h6 dangerouslySetInnerHTML={{ __html: Note?.details }}></h6>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
    )
}

export default NoticeBoardView